module.exports = __webpack_public_path__ + "img/google-color-icon.19b04ead.svg";